import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Posts from './pages/Posts';
import Categories from './pages/Categories';
import Media from './pages/Media';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import HomePage from './pages/HomePage';
import SinglePost from './pages/SinglePost';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Homepage */}
          <Route path="/" element={<HomePage />} />
          
          {/* Single Post */}
          <Route path="/post/:slug" element={<SinglePost />} />

          {/* Contact Page */}
          <Route path="/contact" element={<Contact />} />

          {/* Admin Login */}
          <Route path="/admin_v3jq5z" element={<AdminLogin />} />
          
          {/* Protected Admin Routes */}
          <Route
            path="/admin_v3jq5z/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminDashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/posts"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Posts />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/categories"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Categories />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/media"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Media />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/users"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Users />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/settings"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Settings />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin_v3jq5z/profile"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Profile />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
